<template>
  <div class="d-flex flex-column film-image">
    <van-loading
      v-show="loading"
      class="m-5 p-2 rounded mx-auto loading" />
    <iframe
      v-show="!loading"
      :src="imageInfo.image_url"/>
    <van-dialog
      v-model="hint"
      :before-close="hintClick"
      get-container="body"
      class="hint">
      <div
        v-if="imageInfo.hospital_id == 8"
        class="van-dialog__message--has-title pb-1">
<!--        1、您在出报告后的30天内可免费查看电子胶片，超过体验时间，可自行通过平台购买。-->
      </div>
      <div
        v-else
        class="van-dialog__message--has-title pb-1">1、您拥有3分钟免费查看电子胶片权限，超过体验时间，可自行通过平台购买。</div>
      <div class="van-dialog__message--has-title pb-1">2、一次购买，即享15年使用权限。</div>
    </van-dialog>
  </div>
</template>

<script>
export default {
  name: 'FilmTabImage',
  props: {
    previewSeconds: {
      type: Number,
      required: true,
      default: 0,
    },
    imageInfo: {
      type: Object,
      required: true,
      default() {
        return {
          image_url: '',
        };
      },
    },
    purchased: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      seconds: 0,
      timer: null,
      loading: true,
      // 提示窗口
      hint: false,
    };
  },
  beforeCreate() {
    this.loading = true;
  },
  mounted() {
    setTimeout(() => {
      this.loading = false;
    }, 2000);
    if (!this.purchased) {
      if (this.previewSeconds === -1) {
        this.hint = true;
      } else if (this.seconds === this.previewSeconds) {
        this.showDialog();
      } else {
        this.hint = true;
      }
    }
  },
  deactivated() {
    clearInterval(this.timer);
    this.handleUpdateSeconds();
  },
  beforeDestroy() {
    clearInterval(this.timer);
    this.handleUpdateSeconds();
  },
  methods: {
    hintClick(action, done) {
      done();
      this.setPreviewSeconds();
    },
    showDialog() {
      let message = '您拥有的3分钟免费查看电子胶片时间已满。如需继续使用，请点击“立即购买”';
      if (this.imageInfo.hospital_id === 8) {
        message = '您当前的电子胶片已超过30天的免费査看期，如需继续使用，请点击“立即购买”。';
      }
      this.$dialog
        .confirm({
          title: '支付',
          message,
          confirmButtonText: '立即购买',
        })
        .then(() => {
          this.handleSubmit();
        })
        .catch(() => {
          this.handleCancel();
        });
    },
    setPreviewSeconds() {
      // 每次启动定时器重置时间
      this.seconds = 0;
      this.timer = setInterval(() => {
        this.seconds += 1;
        if (this.seconds === this.previewSeconds) {
          this.showDialog();
        }
      }, 1000);
    },
    async handleUpdateSeconds() {
      await this.$http.post('/cloud-film-api/webapi/preview/update-seconds', {
        preview_second: this.seconds,
        image_id: this.$route.params.id,
      });
    },
    handleSubmit() {
      this.$emit('submit');
    },
    handleCancel() {
      this.handleUpdateSeconds();
      clearInterval(this.timer);
      this.$emit('cancel');
    },
  },
};
</script>

<style scoped>
.film-image {
  width: 100%;
  height: calc(100vh - 44px);
}
.film-image iframe {
  flex: 1;
  border: 0;
}

.hint {
  padding: 8px 16px 0 16px;
}
.text {
  padding: 8px 0;
}
</style>
